import type { Bounds } from "@/config/locations";

/** 중심 좌표에서 radiusKm 반경을 감싸는 위경도 박스. 위도 1도 ≈ 111km, 경도는 cos(lat) 보정. */
export function boundsAroundPoint(
  latitude: number,
  longitude: number,
  radiusKm: number,
): Bounds {
  const latOffset = radiusKm / 111;
  const lngOffset = radiusKm / (111 * Math.cos((latitude * Math.PI) / 180));
  return {
    ne_lat: latitude + latOffset,
    ne_lng: longitude + lngOffset,
    sw_lat: latitude - latOffset,
    sw_lng: longitude - lngOffset,
  };
}
